import { isEmpty } from 'ramda'

import { PICKUP_DELIVERY_CHANNEL } from '../../../constants'
import { calcCrowDistance } from './math'

const getResidentialAddress = (addresses: Address[]) => {
  const residentialAddressType = 'residential'

  return addresses.find(
    (address) => address.addressType === residentialAddressType
  )
}

export const getAddressResidentialFirst = (addresses: Address[]) => {
  const residentialAddress = getResidentialAddress(addresses)

  if (residentialAddress) {
    return residentialAddress
  }

  return addresses[0]
}

export function geoCalcPickupSlaToAddress(
  pickupSla: SLA,
  address: Pick<Address, 'geoCoordinates'> | null
): number | null {
  if (pickupSla?.deliveryChannel !== PICKUP_DELIVERY_CHANNEL) {
    return null
  }

  const coord1 = pickupSla.pickupStoreInfo?.address?.geoCoordinates ?? []
  const coord2 = address?.geoCoordinates ?? []

  if (isEmpty(coord1) || isEmpty(coord2)) {
    return null
  }

  return calcCrowDistance(coord1, coord2)
}

export function getCurrentAddress(
  addresses: Address[],
  storeAddress: Partial<Address> | null
) {
  const shippingAddress = addresses && getAddressResidentialFirst(addresses)

  return shippingAddress || storeAddress
}
